import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDatePicker } from "../../../../../../common/components/masked_inputs/default_date_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

type Props = {
  situacao: number;
  status: number;
  pesquisa: string | Date | null,
  NomeDocumento: string | null,
  DataDe: Date | null,
  DataAte: Date | null,
  onClearFilters: () => void;
  handleStatus: (v: number) => void,
  handleSituacao: (v: number) => void,
  handleNomeDocumento: (v: string | null) => void,
  onDataRangeChange: (de: Date | null, ate: Date | null) => void,
};

export const Header = ({
  situacao,
  status,
  pesquisa,
  NomeDocumento,
  DataDe,
  DataAte,
  handleNomeDocumento,
  onDataRangeChange,
  onClearFilters,
  handleStatus,
  handleSituacao
}: Props) => {

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">

        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">Status</InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Status"
            value={status}
            onChange={(event: SelectChangeEvent<number>) => {
              handleStatus(event.target.value as number)
            }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            <MenuItem value={1}>Em dia</MenuItem>
            <MenuItem value={2}>Vencido</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel id="select-dia-praticavel-label" size="small">Situação</InputLabel>
          <Select
            size="small"
            labelId="select-dia-praticavel-label"
            label="Situação"
            value={situacao}
            onChange={(event: SelectChangeEvent<number>) => {
              handleSituacao(event.target.value as number)
            }}
          >
            <MenuItem value={2}>Todos</MenuItem>
            <MenuItem value={0}>Atual</MenuItem>
            <MenuItem value={1}>Obsoleto</MenuItem>
          </Select>
        </FormControl>

        <div className="w-full md:col-span-2">
         <DefaultDateRangePickerInput
            label='Data'
            dataDe={DataDe}
            dataAte={DataAte}
            onChange={onDataRangeChange}
          />
        </div>
        <div className="w-full col-span-2">
          <DefaultInput
            label="Nome do documento"
            name='Nome do documento'
            value={NomeDocumento}
            onChangeValue={e => handleNomeDocumento(e)}
          />
        </div>
        <div className="flex justify-end col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-4 mt-2">
          <div className="w-full md:w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
        
      </div>
    </CascateList>
  );
};